type NavGuard = "requests" | "admin" | "session";

export type AppNavItem = {
	path: string;
	labelKey: string;
	guard: NavGuard;
	children?: AppNavItem[];
};

/** Sidebar + router stay in sync from this list. */
export const APP_NAV: AppNavItem[] = [
	{ path: "/applications", labelKey: "nav.applications", guard: "requests" },
	{ path: "/users", labelKey: "nav.users", guard: "admin" },
	{ path: "/discounts", labelKey: "nav.discounts", guard: "admin" },
	{ path: "/partners", labelKey: "nav.partners", guard: "admin" },
	{
		path: "/referral",
		labelKey: "nav.referral",
		guard: "admin",
		children: [
			{
				path: "/referral/settings",
				labelKey: "nav.referralSettings",
				guard: "admin",
			},
			{
				path: "/referral/stats",
				labelKey: "nav.referralStats",
				guard: "admin",
			},
			{
				path: "/referral/redemptions",
				labelKey: "nav.referralRedemptions",
				guard: "admin",
			},
		],
	},
	{ path: "/hotel-promos", labelKey: "nav.hotelPromos", guard: "admin" },
	{ path: "/audit-log", labelKey: "nav.auditLog", guard: "admin" },
	{ path: "/account", labelKey: "nav.account", guard: "session" },
];

export function navVisible(
	item: AppNavItem,
	access: { canWorkRequests: boolean; isPortalAdmin: boolean },
): boolean {
	if (item.guard === "requests") {
		return access.canWorkRequests;
	}
	if (item.guard === "admin") {
		return access.isPortalAdmin;
	}
	return true;
}

export function navLeafPaths(items: AppNavItem[] = APP_NAV): string[] {
	return navLeafItems(items).map((item) => item.path);
}

/** Flatten nested groups so a compact icon rail can show only destinations. */
export function navLeafItems(items: AppNavItem[] = APP_NAV): AppNavItem[] {
	return items.flatMap((item) =>
		item.children?.length ? navLeafItems(item.children) : [item],
	);
}
